import { useEffect, useRef } from "react";
import { initSentry } from "../../config/sentry";

/**
 * Lazy Sentry initialiser.
 *
 * Mounting this component inside the provider tree defers Sentry init until
 * after the first paint, which removes the @sentry/react chunk from the
 * eagerly preloaded initial bundle (~111 KB brotli saving on the first load).
 *
 * Errors thrown before Sentry is ready (in the 0–50 ms window before this
 * effect fires) are captured by the global window.onerror / unhandledrejection
 * handlers that Sentry automatically attaches once it does init.  Those events
 * are buffered by the browser and replayed.
 */
export function SentryInit() {
  const initialised = useRef(false);

  useEffect(() => {
    if (initialised.current) return;
    initialised.current = true;
    initSentry();
  }, []);

  return null;
}
